import React from 'react';
import { Link } from 'react-router-dom';
import LogoIcon from '../../images/icons/logo_icon.svg';
import { useGlobalContext } from '../../stores/global';
//import SignupToSellButton from '../SignupToSellButton';
import styles from './Header.module.scss';
import UserMenu from './UserMenu';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';

export default function Header() {
  const { user, dispatch } = useGlobalContext();

  return (
    <header className={styles.container}>
      <div className={styles.content}>
        <div className={styles.leftContent}>
          {user?.name ? (
            <>
              <Link to="/pricing">Precios</Link>
            </>
          ) : (
            <>
              <button
                onClick={() =>
                  dispatch({ type: 'SET_LOGIN_MODAL', payload: 'signup' })
                }
              >
                Registrarse
              </button>
              <Link to="/pricing">Precios</Link>
            </>
          )}
          {/* <SignupToSellButton>Vender</SignupToSellButton> */}
        </div>

        <Link to="/" className={styles.logo}>
          <img src={LogoIcon} alt="Bimmo" />
        </Link>

        <div className={styles.rightContent}>
          {user?.name ? (
            <Box display={'flex'}>
              <Button
                size={'small'}
                variant="outlined"
                color="primary"
                component={Link}
                to="/properties"
              >
                Busca tu propiedad
              </Button>
              <Box paddingLeft={3}>
                <UserMenu />
              </Box>
            </Box>
          ) : (
            <>
              <button
                onClick={() =>
                  dispatch({ type: 'SET_LOGIN_MODAL', payload: 'signin' })
                }
              >
                Iniciar sesión
              </button>
              <Button
                size={'small'}
                variant="outlined"
                color="primary"
                component={Link}
                to="/properties"
              >
                Busca tu propiedad
              </Button>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
